

export function LargeParagraph({ text }) {
    return (
        <p className="text-lg">
            {text}
        </p>
    )
}